module.exports = __webpack_public_path__ + "static/media/imagedemo.15ff8347.jpg";